module.exports = __webpack_public_path__ + "static/header-image-76019360f7a9fe2d01a8071a6ad57c23.png";